import { render, staticRenderFns } from "./ResumenBitacora.vue?vue&type=template&id=01a94a31&"
import script from "./ResumenBitacora.vue?vue&type=script&lang=js&"
export * from "./ResumenBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports